<template>
  <canvas v-show="ready" id="totalWeek" ref="totalWeek" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  props: ["client_customer", "from_date", "to_date", "product"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Kg",
          data: [],
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgba(54, 162, 235, 1)",
          borderWidth: 2,
          tension: 0.5,
          datalabels: {
            anchor: "start",
            formatter: function (value, context) {
              return new Intl.NumberFormat("es-CL").format(parseInt(value)) + " Kg";
            }
          }
        }
        // Usar para los kpi de proyeccion semanal
        // {
        //   label: "Kg",
        //   data: [400000, 200000, 300000],
        //   backgroundColor: "#d1d1d1",
        //   borderColor: "#d1d1d1",
        //   borderWidth: 2,
        //   tension: 0,
        //   datalabels: {
        //     anchor: "start",
        //     formatter: function (value, context) {
        //       return new Intl.NumberFormat("es-CL").format(parseInt(value)) + " Kg";
        //     }
        //   }
        // }
      ]
    };
  },
  async mounted() {
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/arrivals/total_week?client_customer=${this.client_customer}&product=${this.product}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.ready = true;

    let ctx = this.$refs.totalWeek.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            text: "Total semanal"
          }
        }
      }
    });
  }
};
</script>

<style></style>
